import * as actionTypes from './actionTypes';
import { packageService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { hydratePackageConsume } from './hydrators';
import { fetchValidateAccess, fetchValidate } from '@app/src/common/session';

const fetchPackageRequest = () => ({
  type: actionTypes.FETCH_PACKAGE_REQUEST
});

const fetchPackageSuccess = (data) => ({
  type: actionTypes.FETCH_PACKAGE_SUCCESS,
  data
});

const fetchPackageFailure = () => ({
  type: actionTypes.FETCH_PACKAGE_FAILURE
});

const publishPackageRequest = () => ({
  type: actionTypes.PUBLISH_PACKAGE_REQUEST
});

const publishPackageSuccess = (data) => ({
  type: actionTypes.PUBLISH_PACKAGE_SUCCESS,
  data
});

const publishPackageFailure = () => ({
  type: actionTypes.PUBLISH_PACKAGE_FAILURE
});

export const setCategoryPackage = (id) => ({
  type: actionTypes.SET_CATEGORY_PACKAGE,
  id
});

export const setIdPackage = (id) => ({
  type: actionTypes.SET_ID_PACKAGE,
  id
});

export const clearPublishPackageData = () => ({
  type: actionTypes.CLEAR_PUBLISH_PACKAGE_DATA
});

export const clearPackageData = () => ({
  type: actionTypes.CLEAR_PACKAGE_DATA
});

export const clearPackageConsumeData = () => ({
  type: actionTypes.CLEAR_PACKAGE_CONSUME_DATA
});

const fetchPackageConsumeRequest = () => ({
  type: actionTypes.FETCH_PACKAGE_CONSUME_REQUEST
});

const fetchPackageConsumeSuccess = (data) => ({
  type: actionTypes.FETCH_PACKAGE_CONSUME_SUCCESS,
  data
});

const fetchPackageConsumeFailure = () => ({
  type: actionTypes.FETCH_PACKAGE_CONSUME_FAILURE
});

export const fetchPackage = (categoryId: number): Function => {
  return async dispatch => {
    dispatch(fetchPackageRequest());
    await dispatch(fetchValidateAccess());
    try {
      const data = await packageService.get(categoryId);
      dispatch(fetchPackageSuccess(data));
    } catch (e) {
      console.log(`Error action fetchPackage: ${e}`);
      dispatch(fetchPackageFailure());
    }
  }
};

export const publishPackage = (categoryId: number, packageId): Function => {
  return async dispatch => {
    dispatch(publishPackageRequest());
    await dispatch(fetchValidate());
    try {
      const data = await packageService.post(categoryId, {
        package_id: packageId
      });
      if (data.error) {
        dispatch(actionsModalError.openModalError());
        return;
      }
      dispatch(publishPackageSuccess(data.data[0]));
    } catch (e) {
      console.log(`Error action publishPackage: ${e}`);
      dispatch(publishPackageFailure());
    }
  }
};

export const fetchPackageConsume = (userId: number, categoryId?: number): Function => {
  return async dispatch => {
    dispatch(fetchPackageConsumeRequest());
    await dispatch(fetchValidate());
    try {
      const data = await packageService.getConsume(userId, categoryId);
      dispatch(fetchPackageConsumeSuccess(hydratePackageConsume(data && data[0])));
    } catch (err) {
      console.log('Error fetch package consume', err);
      dispatch(fetchPackageConsumeFailure());
      throw new Error(`Error s${err}`)
    }
  }
};